module.exports = __webpack_public_path__ + "static/media/500.332276ff.png";